/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Dropdown, Segment, Table } from "semantic-ui-react";
import { TextField } from "@mui/material";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { changeTool } from "../slices/footer/footerSlice";
import { selectCurrentUserApiToken, selectCurrentUserName } from "../slices/currentUser/currentUserSlice";
import { fevirPublicationStatusActive, fevirPublicationStatusDraft } from "../dictionaries/THOandFHIRValueSets";
import submitResource from "../resourceComponents/resourceDisplayCommonFunctions/submitResource";
import GenericToggleButtons from "./GenericToggleButtons";

const submitCitationResource = async (apiToken, navigate, dispatch, fhirEntryState) => {
    if (fhirEntryState.title.trim() === "") {
        alert("title field is missing");
        return;
    }

    let fhirEntry = {
        "resourceType": "Citation",
        "extension": [
            {
                "url": "http://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-publication-status",
                "valueCodeableConcept": fhirEntryState.status === "active" ?
                    fevirPublicationStatusActive : fevirPublicationStatusDraft
            }
        ],
        "title": fhirEntryState.title,
        "description": fhirEntryState.description,
        "useContext": [{
            "code": {
                "system": "http://hl7.org/fhir/citation-classification-type",
                "code": "fevir-platform-use",
                "display": "FEvIR Platform Use"
            },
            "valueCodeableConcept":
            {
                "coding": [
                    {
                        "system": "http://hl7.org/fhir/citation-artifact-classifier",
                        "code": "project-specific",
                        "display": "Project Specific"
                    }
                ]
            }
        }],
        "citedArtifact": {}
    };

    let contributorRolesOrganized = { "author": [], "editor": [], "reviewer": [], "endorser": [], "recorder": [] }
    for (let x in fhirEntryState.citationResourceContributors) {
        let role = fhirEntryState.citationResourceContributors[x].role;
        if (role === "Creator") {
            contributorRolesOrganized.author.push(fhirEntryState.citationResourceContributors[x]);
        } else if (role === "Editor") {
            contributorRolesOrganized.editor.push(fhirEntryState.citationResourceContributors[x]);
        } else if (role === "Reviewer") {
            contributorRolesOrganized.reviewer.push(fhirEntryState.citationResourceContributors[x]);
        } else if (role === "Endorser") {
            contributorRolesOrganized.endorser.push(fhirEntryState.citationResourceContributors[x]);
        } else if (role === "Recorder") {
            contributorRolesOrganized.recorder.push(fhirEntryState.citationResourceContributors[x]);
        }
    }
    for (let key in contributorRolesOrganized) {
        if (contributorRolesOrganized[key].length && fhirEntry[key] === undefined) {
            fhirEntry[key] = [];
        }
        contributorRolesOrganized[key].forEach((contributor, x) => {
            if (x >= fhirEntry[key].length) {
                fhirEntry[key].push({});
            }
            if (fhirEntry[key][x].name !== contributor.name) {
                fhirEntry[key][x] = {};
            }
            fhirEntry[key][x].name = contributor.name; //Why can't this just move into the if statement? Only reason I can think of is if .name is an object
        });
    }
    submitResource(fhirEntry, apiToken, navigate, dispatch, fhirEntryState.status);
};

// eslint-disable-next-line no-empty-pattern
const CreateNewCitationPage = ({ }) => {
    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const userName = useSelector(selectCurrentUserName);
    const navigate = useNavigate();

    const [fhirEntryState, setFhirEntryState] = useState({
        "title": "",
        "description": "",
        "citationResourceContributors": [{ "name": userName, "role": "Creator" }],
        "status": "active"
    });

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Citation Builder"));
        dispatch(changeTool("FEvIR®: Citation Builder"));
    }, [])

    useEffect(() => {
        setFhirEntryState(prevState => {
            return {
                ...prevState,
                "citationResourceContributors": [{ "name": userName, "role": "Creator" }]
            };
        });
    }, [userName]);

    return (
        <div>
            <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
                <h2 style={{ textAlign: "center", color: "#AC3B61" }}>FEvIR<sup style={{ verticalAlign: "super", fontSize: "x-small" }}>®</sup>: Citation Builder</h2>
                <br /><br />
                {apiToken ?
                    <>
                        <TextField style={{ width: "760px" }} multiline className="inputField" type='text'
                            label={'Citation Title'} size="small" variant='outlined'
                            value={fhirEntryState.title}
                            onChange={(e) => {
                                setFhirEntryState(prevState => {
                                    return {
                                        ...prevState,
                                        "title": e.target.value
                                    };
                                });
                            }} />
                        <br /><br />
                        <TextField style={{ width: "760px" }} multiline className="inputField" type='text'
                            label={'Citation Description'} size="small" variant='outlined'
                            value={fhirEntryState.description}
                            onChange={(e) => {
                                setFhirEntryState(prevState => {
                                    return {
                                        ...prevState,
                                        "description": e.target.value
                                    };
                                });
                            }} />
                        <br /><br />
                        <span>
                            <b style={{ fontSize: "1.1em" }}>Contributors: </b>
                            <Table>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Contributor Name</Table.HeaderCell>
                                        <Table.HeaderCell>Contributor Role</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {fhirEntryState.citationResourceContributors.map((contributorEntry, index) => {
                                        return <Table.Row key={index}>
                                            <Table.Cell>
                                                <TextField style={{ width: "100%" }} multiline
                                                    className="inputField" type='text' label={"Name"} size="small"
                                                    variant='outlined' value={contributorEntry.name || ''}
                                                    onChange={(e) => {
                                                        setFhirEntryState(prevState => {
                                                            let newArray = JSON.parse(JSON.stringify(prevState.citationResourceContributors));
                                                            newArray[index].name = e.target.value;
                                                            return { ...prevState, citationResourceContributors: newArray };
                                                        });
                                                    }} />
                                            </Table.Cell>
                                            <Table.Cell>
                                                <Dropdown
                                                    name="citationResourceContributorRole"
                                                    placeholder="Role"
                                                    closeOnChange selection clearable selectOnBlur={false} autoComplete="off"
                                                    style={{ width: "100px" }}
                                                    options={[
                                                        { key: "Creator", text: "Creator", value: "Creator" },
                                                        { key: "Editor", text: "Editor", value: "Editor" },
                                                        { key: "Reviewer", text: "Reviewer", value: "Reviewer" },
                                                        { key: "Endorser", text: "Endorser", value: "Endorser" },
                                                        { key: "Recorder", text: "Recorder", value: "Recorder" }
                                                    ]}
                                                    value={contributorEntry.role || ''}
                                                    onChange={(e, data) => {
                                                        setFhirEntryState(prevState => {
                                                            let newArray = JSON.parse(JSON.stringify(prevState.citationResourceContributors));
                                                            newArray[index].role = data.value;
                                                            return { ...prevState, citationResourceContributors: newArray };
                                                        });
                                                    }}
                                                />
                                            </Table.Cell>
                                        </Table.Row>;
                                    })
                                    }
                                </Table.Body>
                            </Table>
                            <Button className="formButton" style={{ color: "#000000" }}
                                content="+ Add Contributor"
                                onClick={() => {
                                    setFhirEntryState(prevState => {
                                        let prevField = JSON.parse(JSON.stringify(prevState["citationResourceContributors"]));
                                        prevField.push({ "role": "", "name": "" });
                                        return { ...prevState, "citationResourceContributors": prevField };
                                    });
                                }} />
                        </span>
                        <br /><br />
                        <GenericToggleButtons thin={true} boxes={true} togglable={false}
                            values={["active", "draft"]}
                            labels={["Publish (anyone can view)", "Draft (only editors can view)"]}
                            fieldLabel="status" elementName="status"
                            startingValue={fhirEntryState.status} setter={setFhirEntryState}
                        />
                        <br />
                        <br />
                        <Button className="formButton positive" content="Submit" compact
                            onClick={() => {
                                submitCitationResource(apiToken, navigate, dispatch, fhirEntryState);
                            }} />
                    </>
                    :
                    <p>Please login. (If you do not have an account click Sign In and log in with your Google Account.)</p>
                }
            </Segment>
        </div>
    );
};

export default CreateNewCitationPage;